const Card = ({ title, children }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      {title && (
        <div className="px-6 py-4 border-b text-lg font-semibold">
          {title}
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
};

export default Card;
